import { DatePipe, formatDate } from '@angular/common';
import { Component, Input, NgZone, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ITimeSlot } from 'src/app/interfaces/i-time-slot';
import { Session } from 'src/app/models/session';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { UserService } from 'src/app/services/user.service';
import { ViewSessionComponent } from '../view-session/view-session.component';
import { TimeSlotType } from 'src/app/models/time-slot-type';

@Component({
  selector: 'app-already-session',
  templateUrl: './already-session.component.html',
  styleUrls: ['./already-session.component.scss'],
})
export class AlreadySessionComponent implements OnInit {

  @Input() sessionForm : FormGroup;

  @Input() startDate : Date;
  @Input() endDate : Date;
  selectedDate : Date;

  slots : Array<Session> = [];
   
  spinner : boolean = false;
  isCalendarTimeEndShow: boolean;
  isCalendarTimeStarShow: boolean;

  todayDate: string;
  timeSlot: number = 60;
  slotTypefreeSlot : number = TimeSlotType.FreeSlot;
  slotTypeSession : number = TimeSlotType.Session;


  constructor(
    public modalCtrl : ModalController,
    private apiProvider: ApiProviderService,
    private datePipe: DatePipe,
    private userService: UserService,
    public zone: NgZone
    ) { }

  ngOnInit() {
    this.todayDate = formatDate(new Date(), 'HH:mm:ss','fr-CA');
    this.selectedDate = this.startDate;
    this.availableSlot(this.timeSlot);
  }

  confirm(){
    this.modalCtrl.dismiss("fuckYOU", "confirm");
  }

  cancel(){
    this.modalCtrl.dismiss("fuckYOU", "cancel");
  }

  availableSlot(duration : number = 60){
    this.spinner = true;
    this.apiProvider.getSchedulesPerDay(this.userService.getUser().id, this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd H:mm:ss'), duration).subscribe(
      (slots) => {

        const dateCheck = new Date(this.selectedDate);
        dateCheck.setHours(0,0,0,0);
        const todayCheck = new Date();
        todayCheck.setHours(0,0,0,0);

        if(todayCheck.toISOString() == dateCheck.toISOString()){

          this.sessionForm.controls.StartDate.setValue(formatDate(new Date(), 'yyyy-MM-ddTHH:mm:ss','fr-CA'));
          this.todayDate = formatDate(new Date(), 'yyyy-MM-ddTHH:mm:ss','fr-CA');
          

          this.slots = slots.filter(
            (slot) => {
              if(new Date(slot.startDate) >= new Date()){
                return slot;
              }
            }
          );
        }else{
          this.todayDate = formatDate(new Date().setHours(0,0,0,0), 'yyyy-MM-ddTHH:mm:ss','fr-CA')
          this.slots = slots;
        }

        this.spinner = false;
      },
      (err) => {
        this.spinner = false;
      }
    )
  }

  slotSelected(slot : ITimeSlot){
    this.sessionForm.controls.StartDate.setValue(slot.startDate);
    this.sessionForm.controls.EndDate.setValue(slot.endDate);
  }

  inverse(varToInverse: string)
  {
    if(varToInverse === 'isCalendarDateStarShow'){
      this.isCalendarTimeEndShow = false;
      this.isCalendarTimeStarShow = false;
    }
    if(varToInverse === 'isCalendarTimeStarShow'){
      this.isCalendarTimeEndShow = false;
      this.isCalendarTimeStarShow = !this.isCalendarTimeStarShow;
    }

    if(varToInverse === 'isCalendarDateEndShow'){
      this.isCalendarTimeStarShow = false;
      this.isCalendarTimeEndShow = false;
    }
    if(varToInverse === 'isCalendarTimeEndShow'){
      this.isCalendarTimeStarShow = false;
      this.isCalendarTimeEndShow = !this.isCalendarTimeEndShow;
    }
  }

  changeDay(direction : string){

    let startDate = new Date(this.sessionForm.controls.StartDate.value);
    let endDate = new Date(this.sessionForm.controls.EndDate.value);

    let d = new Date();
    d.setHours(0,0,0,0);

    if(direction == 'forward'){
      startDate.setDate(startDate.getDate() + 1);
      this.sessionForm.controls.StartDate.setValue(formatDate(startDate, 'yyyy-MM-ddTHH:mm:ss','fr-CA'));

      endDate.setDate(endDate.getDate() + 1);
      this.sessionForm.controls.EndDate.setValue(formatDate(endDate, 'yyyy-MM-ddTHH:mm:ss','fr-CA'));

      this.selectedDate = startDate;
      this.availableSlot(this.timeSlot);
    }

    if(direction == 'back'){
      startDate.setDate(startDate.getDate() - 1);
      endDate.setDate(endDate.getDate() - 1);
      if(startDate >= d){
        this.sessionForm.controls.StartDate.setValue(formatDate(startDate, 'yyyy-MM-ddTHH:mm:ss','fr-CA'));
        this.sessionForm.controls.EndDate.setValue(formatDate(endDate, 'yyyy-MM-ddTHH:mm:ss','fr-CA'));
        this.selectedDate = startDate;
        this.availableSlot(this.timeSlot);
      }
    }

    
  }

  showSession(slot : ITimeSlot){
    
    this.apiProvider.getSession(slot.id).subscribe(
      async (session: Session) =>{
        const viewSessModal = await this.modalCtrl.create({
          component : ViewSessionComponent,
          componentProps : {
            session : session
          }
        });

        viewSessModal.present();
      }
    );
    
  }

  startDateChanged(event : any){
    if(event.detail)
    {
      if(new Date(event.detail?.value).getTime() >= new Date(new Date(new Date(this.sessionForm.controls.EndDate.value).setMilliseconds(0)).setSeconds(0)).getTime())
      {
        this.sessionForm.controls.EndDate.setValue(formatDate(new Date(event.detail?.value).setHours( new Date(event.detail?.value).getHours() + 1), 'yyyy-MM-ddTHH:mm:ss','fr-CA'));
      }
    }
  }

  handleChange(event : any) {
    this.timeSlot = +event.detail.value;
    this.availableSlot(+event.detail.value)
  }

}
